import { GamepadVariantOutlineIcon } from './GamepadVariantOutlineIcon';

/**
 * author: Michael Richins
 * id 25A261F0-9C5E-4103-88C8-70CEBA27270D
 * name gamepad-variant-outline
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gamepad-variant-outline.svg
 * tags
 * - Gaming / RPG 
 */
export const ControllerVariantOutlineIcon = GamepadVariantOutlineIcon;
export default ControllerVariantOutlineIcon